import React from "react";
import { InjectedTranslationContext } from ".";
import { SUPPORTED_LOCALES } from "../../constants";
import { Translations } from "../../models/locale";
import translations from "./translations";

/**
 * Takes injected translations and combines them with the default ones
 */
export const useCombinedTranslations = (): Translations => {
  const injectedTranslations =
    React.useContext(InjectedTranslationContext) || {};
  const combinedTranslations = {
    "en-US": {},
    "en-CA": {},
    "fr-CA": {},
    "pt-BR": {},
  };
  SUPPORTED_LOCALES.forEach((locale) => {
    combinedTranslations[locale] = {
      ...translations[locale],
      ...injectedTranslations[locale],
    };
  });
  return combinedTranslations;
};
